import React from "react";
import "./Guarantees.css";
import {
  FaSearch,
  FaTags,
  FaGraduationCap,
  FaUsers,
  FaChartLine,
  FaCogs,
} from "react-icons/fa";

const guarantees = [
  { icon: <FaSearch />, text: "Maßgeschneiderte Analyse" },
  { icon: <FaTags />, text: "Faire Preise" },
  { icon: <FaGraduationCap />, text: "Geschultes Personal" },
  { icon: <FaUsers />, text: "Feste Teams" },
  { icon: <FaChartLine />, text: "Konstante Qualität" },
  { icon: <FaCogs />, text: "Systematisches Reklamationsmanagement" },
];

const Guarantees = () => (
  <section className="guarantees-section">
    <h2>
      Für Ihre <span className="blue-text">Reinigung</span> garantieren wir:
    </h2>
    <div className="guarantees-grid">
      {guarantees.map((item, i) => (
        <div className="guarantee-box" key={i}>
          <div className="icon">{item.icon}</div>
          <p>{item.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Guarantees;
